import React from 'react';

const OnLive = () => {
    return <div className="on-live">Live</div>;
};

export default OnLive;
